(function () {
    'use strict';

    angular.module("imApp").factory("requisitionCreateFromService", ['$ihttp', function ($ihttp) {
        let service = {
            listStocks: function (parms) {
                return $ihttp.post({
                    method: 759,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
